export const environment = {
  production: true,
  name: 'Empower The Team',
  apiUrl: '/core',
  features: {
    news: false,
    sport: true,
    offlineChanges: false,
  },
  locale: 'en-gb',
};
